import React, { Component } from 'react';
import PropTypes from "prop-types";
import { Container, NoData } from '../ChallengeDashboardV2/CompletedChallenge/styles';
import _ from 'lodash';
import Waiting from '../Waiting/index';
import { connect } from 'react-redux';
import { setSelectedYear } from '../../redux/actions/companyDashboard/index';
import {getAdminCompletedChallenges} from '../../redux/actions/challengeActions/index'
import {GetAdminChallenges} from '../../redux/constants/apiConstants'
import { fetchApi } from "../../utils/methods";
import CompletechallengeCard from './completeChallenge'
import { toggleDummyChallenges } from "../../redux/actions";
import {CardWrapper} from './style'

class CompletedChallengeV2 extends Component {

  constructor(props) {
    super(props);
    this.state = {
      challengesData: [],
      onHover: null
    };
  }

  componentDidMount() {
    const { selectedOption, companyId } = this.props;
    this.fetchSynchrisemployees(selectedOption, companyId)
  }

  componentDidUpdate(prevProps) {
    const{ selectedOption, companyId } = this.props;
    if(selectedOption !== prevProps.selectedOption){
      this.fetchSynchrisemployees(selectedOption, companyId)
    }
  }

  fetchSynchrisemployees = async (year) => {
    const companyId = this.props.companyId; 
    try {
      const response = await fetchApi(`${GetAdminChallenges}/${companyId}/${year}`, "GET");
      if (response?.message) {
        // toast.error(res.message);
      }
      else {
        this.setState({challengesData: response?.data[0]})
      }
    } catch (error) {
      // toast.error(error.message);
    }
  };

  challengeRedirect = (id) => {
    this.props.history.push(`/company/challenges/completed/${id}`)
  };

  updateDropdown = (year) => {
    const { setSelectedYear, getAdminCompletedChallenges, companyId } = this.props;
    setSelectedYear(year);
    getAdminCompletedChallenges(year, companyId);
  };

  onEnterMouse = (id) => {
    this.setState({
      onHover: id
    })
  };

  onLeaveMouse = () => {
    this.setState({
      onHover: -1
    })
  };

  render() {
    const { challengesData } = this.state;
    const { history } = this.props;
    if (!challengesData || _.isNull(challengesData) || _.isUndefined(challengesData)) {
      return <Waiting />
    }
    let adminChallengesData = challengesData.filter((obj) => obj.is_user_challenge === 0)
    return (
      <Container pagePadding>
        <div className="mainContainer">
          {adminChallengesData && adminChallengesData.length > 0 ?
            <CardWrapper>
              {adminChallengesData && adminChallengesData.length > 0 && adminChallengesData.map((challenge, index) => (
                <CompletechallengeCard
                  challenge={challenge}
                  history={history}
                  key={index}
                  toggleDummyChallenges={toggleDummyChallenges}
                  margin={index}
                  adminChallenge={'1'}
                  onEnterMouse={this.onEnterMouse}
                  onLeaveMouse={this.onLeaveMouse}
                  onHover={this.state.onHover}
                />
              ))}
            </CardWrapper> : <NoData>{("No Data Present")}</NoData>}
        </div>
      </Container>
    );
  }
}

CompletedChallengeV2.propTypes = {
  history: PropTypes.object.isRequired,
  yearList: PropTypes.array,
  selectedYearInfo: PropTypes.number,
  setSelectedYear: PropTypes.func,
  getAdminCompletedChallenges: PropTypes.func,
  t: PropTypes.func,
  companyId: PropTypes.number,
  selectedOption: PropTypes.number
};

const mapStateToProps = (state) => ({
  activeTab: state.challenges.activeTab,
  isLoading: state.challenges.isLoading,
});

const mapDispatchToProps = (dispatch) => ({
  setSelectedYear: (year) => dispatch(setSelectedYear(year)),
  getAdminCompletedChallenges: (year, companyId) => dispatch(getAdminCompletedChallenges(year, companyId)),
});

export default connect(mapStateToProps, mapDispatchToProps)((CompletedChallengeV2));